import React from 'react';
import PropTypes from 'prop-types';
import { cn } from '@/lib/utils';
import { AlertCircle, Info } from 'lucide-react';

const Alert = ({ 
  variant = 'default', 
  title, 
  description, 
  children, 
  className,
  icon: Icon 
}) => {
  const variants = {
    default: 'bg-blue-50 border-blue-200 text-blue-900',
    warning: 'bg-yellow-50 border-yellow-200 text-yellow-900',
    destructive: 'bg-red-50 border-red-200 text-red-900',
    info: 'bg-blue-50 border-blue-200 text-blue-900',
  };

  const defaultIcon = variant === 'warning' || variant === 'destructive' ? AlertCircle : Info;
  const IconComponent = Icon || defaultIcon;

  return (
    <div
      className={cn(
        'rounded-lg border p-4 flex items-start gap-3',
        variants[variant],
        className
      )}
    >
      <IconComponent className="h-5 w-5 shrink-0 mt-0.5" />
      <div className="flex-1 min-w-0">
        {title && (
          <h4 className="font-semibold mb-1">{title}</h4>
        )}
        {description && (
          <p className="text-sm">{description}</p>
        )}
        {children}
      </div>
    </div>
  );
};

Alert.propTypes = {
  variant: PropTypes.oneOf(['default', 'warning', 'destructive', 'info']),
  title: PropTypes.string,
  description: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  icon: PropTypes.elementType,
};

const AlertDescription = ({ children, className }) => {
  return (
    <p className={cn('text-sm', className)}>
      {children}
    </p>
  );
};

AlertDescription.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export { Alert, AlertDescription };

